const BASE_URL = 'https://app.yaper.co/api/v1';

export const sendOtp = async (mobile) => {
  const response = await fetch(`${BASE_URL}/sessions`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      mobile,
      source: 'ca',
      modes: 'mobile',
    }),
  });

  const data = await response.json();
  return data;
};

export const verifyOtp = async (mobile, otp) => {
  const response = await fetch(`${BASE_URL}/sessions/verify_otp`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      mobile,
      otp,
    }),
  });

  const data = await response.json();
  return data;
};

export const saveName = async (token, firstName, lastName, email) => {
  const response = await fetch(`${BASE_URL}/users/me`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'session-id': token,
    },
    body: JSON.stringify({
      first_name: firstName,
      last_name: lastName,
      email,
    }),
  });

  const data = await response.json();
  return data;
};
